import angular from 'angular';
import '../../services/errors';
import '../../services/tags-groups';
import { get } from 'lodash';

const module = angular.module('whyline.modals.tags-groups', [
  'whyline.services.tags-groups',
  'whyline.services.errors',
]);

const TagsGroupsModalController = (
  $scope,
  $uibModalInstance,
  $translate,
  $timeout,
  dialog,
  NotificationService,
  ErrorService,
  TagsGroupsService,
  tagGroupId,
) => {
  'ngInject';

  $scope.tagGroup = {
    name: '',
    order: 1,
    tags: [],
  };

  $scope.currentTag = {
    value: '',
  };

  const init = () => {
    if (tagGroupId) {
      TagsGroupsService.GetOneAsPromiseFromServer(tagGroupId).then((tagGroup) => {
        $timeout(async () => {
          const savedTags = tagGroup.tags.map((tag) => ({
            tagName: tag.tagName,
            placeIds: tag.placeIds,
          }));

          const savedTagGroup = {
            _id: tagGroup._id,
            name: tagGroup.name,
            order: tagGroup.order,
            tags: savedTags,
          };

          $scope.tagGroup = TagsGroupsService.Copy(savedTagGroup);
        });
      });
    }
  };

  const validate = () => {
    const { name } = $scope.tagGroup;
    const order = parseInt($scope.tagGroup.order, 10);
    const { tags } = $scope.tagGroup;

    if (!name) {
      NotificationService.Warning($translate.instant('mandatory_tag_group_name'));
      return false;
    }

    if (name.length > 25) {
      NotificationService.Warning($translate.instant('tag_group_name_length'));
      return false;
    }

    if (!order) {
      NotificationService.Warning($translate.instant('mandatory_tag_group_order'));
      return false;
    }

    if (order < 1 || order > 10000) {
      NotificationService.Warning($translate.instant('tag_group_order_range'));
      return false;
    }

    if (!tags.length) {
      NotificationService.Warning($translate.instant('mandatory_tag_group_tags'));
      return false;
    }

    return true;
  };

  const deleteTag = (tagName) => {
    const tagFoundIndex = $scope.tagGroup.tags.findIndex((t) => t.tagName === tagName);
    $scope.tagGroup.tags.splice(tagFoundIndex, 1);
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.inputTag = (event) => {
    if (
      (event.which === 188 && $scope.currentTag.value !== ',' && $scope.currentTag.value !== '<') ||
      (event.which === 13 && $scope.currentTag.value !== ' ')
    ) {
      const tag =
        $scope.currentTag.value.indexOf(',') !== -1
          ? $scope.currentTag.value.substring(0, $scope.currentTag.value.indexOf(','))
          : $scope.currentTag.value;

      if (tag !== '') {
        $scope.tagGroup.tags.push({
          tagName: tag,
        });

        $scope.currentTag.value = '';
      }
    }
  };

  $scope.removeTag = (tagName) => {
    if (tagGroupId) {
      dialog
        .confirm($translate.instant('tag-group.remove-tag'))
        .then(() => deleteTag(tagName))
        .catch(() => 'canceled');
    } else {
      deleteTag(tagName);
    }
  };

  $scope.save = () => {
    if (validate()) {
      const { name } = $scope.tagGroup;

      let promise = null;
      let message = '';

      $scope.tagGroup.tags = $scope.tagGroup.tags.map((tag) => {
        if (!tag.placeIds) {
          tag.placeIds = [];
        }
        return tag;
      });

      if (tagGroupId) {
        promise = TagsGroupsService.Update($scope.tagGroup);
        message = $translate.instant('tag_group_{name}_updated_succ').replace('{name}', name);
      } else {
        promise = TagsGroupsService.Create($scope.tagGroup);
        message = $translate.instant('tag_group_{name}_created_succ').replace('{name}', name);
      }

      promise
        .then(() => {
          NotificationService.Success(message);
          $uibModalInstance.close('success');
        })
        .catch((error) => {
          const errorData = get(error, 'data', undefined);

          if (errorData && errorData.statusCode === 406) {
            const errorMessage = $translate.instant(errorData.reason);

            NotificationService.Warning(errorMessage);
          } else {
            ErrorService.handler(error);
          }
        });
    }
  };

  init();
};

module.exports = module.controller('TagsGroupsModalController', TagsGroupsModalController);
